export const copyButtonTestId = "components/fragments/button/copy-button/CopyButton";
export const copyToastTestId = "components/fragments/button/copy-button/Toast";
export const defaultSuccessMessage = "コピーしました";
export const defaultFailMessage = "コピー失敗しました";
